import React from "react";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const { t } = useTranslation("common");

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-white">
      <p className="text-sm font-normal tracking-[0.18em] text-slate-700">
        {t("loading.content")}
      </p>
      <div className="h-1.5 w-44 overflow-hidden rounded-full bg-slate-200">
        <div className="h-full w-1/2 animate-pulse rounded-full bg-sky-500" />
      </div>
    </div>
  );
};

export default Loader;
